import { Component, OnInit, Injector } from '@angular/core';
import { CompetitionInformationComponent } from '../competition-information/competition-information.component';

@Component({
  selector: 'app-mobile-competition-informations',
  template: require('./mobile-competition-informations.component.html'),
  styles: [require('./mobile-competition-informations.component.scss')]
})
export class MobileCompetitionInformationsComponent extends CompetitionInformationComponent implements OnInit {

  constructor(injector: Injector) {
    super(injector);


   }

  // ngOnInit() {
  //   this.afterLoadCompetiton();
  // }

}
